import { map, isObject, isEmpty } from 'underscore'

export const hasEmptyOptions = (options) => !options || !isObject(options) || isEmpty(options)

export function appendOptions(url, options) {
  if (hasEmptyOptions(options)) return url
  const queries = map(options, (value, key) => `${key}=${value}`)
  return `${url}?${queries.join('&')}`
}
